export const REGISTER_FORM = "REGISTER_FORM";
export const PERSONAL_INFORMATION_FORM = "PERSONAL_INFORMATION_FORM";
export const BUSINESS_INFORMATION_FORM = "BUSINESS_INFORMATION_FORM";
export const COMPANY_FORM = "COMPANY_FORM";
export const ACCOUNT_SETTINGS_FORM = "ACCOUNT_SETTINGS_FORM";
export const INVOICES_PAGE_COUNT = 30;
